export const QA_NAME_LISTING_PROFILE_HEADER_AVATAR =
  'listingProfileHeaderAvatar'

export const QA_NAME_LISTING_PROFILE_HEADER_EDIT_TITLE =
  'listingProfileHeaderEditTitleBtn'
